module.exports = __webpack_public_path__ + "media/images/online_talks/robot_2-5d3397c0e0de60b9149c927d4d1c8b2f.png";